import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ExpertService } from 'src/app/shared/techExpert/expert.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-reply-to-ticket',
    templateUrl: './reply-to-ticket.component.html',
    styleUrls: ['./reply-to-ticket.component.css'],
    standalone: false
})
export class ReplyToTicketComponent implements OnInit {

  ticket
  role
  serverErrorMessages: string
  ticketReplyForm = new FormGroup({
    message: new FormControl('Reply from Tech Expert', Validators.required)
  })
  constructor(private loginService: LoginService, private expertService: ExpertService, private router : Router) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )

      this.expertService.currentTicket.subscribe( ticket => {
        this.ticket = ticket;
       //console.log(this.ticket)
      })

      if(Object.keys(this.ticket).length === 0){
       //console.log('PLEASE GO BACK')
        window.alert('Please Select a ticket to reply')
        this.router.navigateByUrl('get-assigned-tickets')
      }
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  onSubmit(){
    this.expertService.replyToTicket({ expertMessage: this.ticketReplyForm.get('message').value, ticketID: this.ticket._id },null).subscribe(
      res => {
       //console.log('Reply Successfull');
        alert('Your Reply was successfully Taken, Thank you for your service');
        this.router.navigateByUrl('get-assigned-tickets');
      },
      err => {
       //console.log('Reply Error from server');
       console.log(err)
      }
      
    )
  }

}
